import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";

import { useEnterpriseMembersContext } from "../../../../contexts/EnterpriseMembersContext";

import CreditsList from "../../../Member/Credits";

export default function Credits() {
  const { dispatch, actions, state } = useEnterpriseMembersContext();

  return (
    <>
      <Modal
        className="student inmodal auto without-overflow"
        show={state.showCredits}
        onHide={() => actions.hideCredits(dispatch)}
        bsSize="large"
      >
        <Modal.Header closeButton>
          <Modal.Title>Credits</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {state.currentMember && <CreditsList member={state.currentMember} />}
        </Modal.Body>
      </Modal>
    </>
  );
}
